<template>
  <main class="wrapper" data-app >
    <Header/>
    <article class="content w-100">
      <MenuBar :global_route="this.$route.name"/>
      <router-view/>
    </article>
  </main>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
  import Header   from  '@/components/HeaderComponent/Header.vue'
  import MenuBar  from  '@/components/MenuBarComponent/MenuBar.vue'

  export default {
    name: 'ProtectedView',
    components: {
      Header,
      MenuBar,
    },
    computed: 
    {
      isLogin() {
        return this.$route.name === 'login'
      }
    },
    async mounted()
    {
        await new Promise(resolve => setTimeout(resolve, 2500))
    },
    async created()
    {
    }
  }
</script>


